import React, { Component, Fragment } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Grid,
  Typography
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FaArrowLeft, FaPencilAlt, FaPlus, FaCheck, FaCheckCircle } from "react-icons/fa";
import MyButton from '../../../utils/MyButton';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { editEquipoDetails, getEquipo, clearErrors } from '../../../redux/actions/dataactions';

export class DetallesEquipo extends Component {

    constructor(){
        super();
        this.state={
            nombre:'',
            marca:'',
            registroinvima:'',
            modelo:'',
            serie:'',
            ubicacion:'',
            servicio:'',
            tipo:'',
            clase:'',
            riesgo:'',
            movilfijo:'',
            clasbiomedica:'',
            reqcalibracion:'',
            adquisicion:'',
            costo:'',
            fabricacion:'',
            operacion:'',
            vidautil:'',
            proveedor:'',
            proveedortel:'',
            proveedoremail:'',
            tipotec:'',
            fuente:'',
            tensionmin:'',
            tensionmax:'',
            corrientemin:'',
            corrientemax:'',
            temperatura:'',
            frecuencia:'',
            potencia:'',
            presion:'',
            alto:'',
            ancho:'',
            largo:'',
            peso:'',
            idinventario:'',
            urlfactura:'',
            urlmanual:'',
            errors:{},
            aprobado:{},
             // New variables
             fechainstalacion: '',
             garantia: '',
             fechainiciogarantia: '',
             fechafingarantia: '',
             velocidad: '',
             capacidad: '',
             tipouso: '',
             pais: '',
             descripcion: '',
             nombrefabricante: '',
             emailfabricante: '',
             telfabricante: '',
             rutinamto: '',
             recomendaciones: '',
             accesorio: '',
             accesorionombre1: '',
             accesorioref1: '',
             accesorioserie1: '',
             accesorionombre2: '',
             accesorioref2: '',
             accesorioserie2: '',
             accesorionombre3: '',
             accesorioref3: '',
             accesorioserie3: '',
            open:false
        };
        
    };
    static getDerivedStateFromProps(props, state) {
      const newState = {};
  
      if (props.UI.errors) {
          newState.errors = props.UI.errors;
      }
  
      if (props.UI.aprobado) {
         newState.aprobado = props.UI.aprobado;
      }
  
      return Object.keys(newState).length > 0 ? newState : null;
  }
  formatearFecha = (fecha) => {
    if (!fecha) return '';
    if (typeof fecha !== 'string') return fecha;
    const partes = fecha.split('/');
    if (partes.length !== 3) return fecha;
    const [dia, mes, año] = partes;
    return `${año}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
  };
  mapUserDetailsToState = (equipo) => {
    this.setState({
        nombre:equipo.nombre?equipo.nombre:'',
        marca:equipo.marca?equipo.marca:'',
            registroinvima:equipo.registroinvima?equipo.registroinvima:'',
            modelo:equipo.modelo?equipo.modelo:'',
            serie:equipo.serie?equipo.serie:'',
            ubicacion:equipo.ubicacion?equipo.ubicacion:'',
            servicio:equipo.servicio?equipo.servicio:'',
            tipo:equipo.tipo?equipo.tipo:'',
            clase:equipo.clase?equipo.clase:'',
            riesgo:equipo.riesgo?equipo.riesgo:'',
            movilfijo:equipo.movilfijo?equipo.movilfijo:'',
            clasbiomedica:equipo.clasbiomedica?equipo.clasbiomedica:'',
            reqcalibracion:equipo.reqcalibracion?equipo.reqcalibracion:'',
            adquisicion:equipo.adquisicion?equipo.adquisicion:'',
            costo:equipo.costo?equipo.costo:'',
            fabricacion: equipo.fabricacion ? this.formatearFecha(equipo.fabricacion) : '',
            operacion: equipo.operacion ? this.formatearFecha(equipo.operacion) : '',
            vidautil:equipo.vidautil?equipo.vidautil:'',
            proveedor:equipo.proveedor?equipo.proveedor:'',
            proveedortel:equipo.proveedortel?equipo.proveedortel:'',
            proveedoremail:equipo.proveedoremail?equipo.proveedoremail:'',
            tipotec:equipo.tipotec?equipo.tipotec:'',
            fuente:equipo.fuente?equipo.fuente:'',
            tensionmin:equipo.tensionmin?equipo.tensionmin:'',
            tensionmax:equipo.tensionmax?equipo.tensionmax:'',
            corrientemin:equipo.corrientemin?equipo.corrientemin:'',
            corrientemax:equipo.corrientemax?equipo.corrientemax:'',
            temperatura:equipo.temperatura?equipo.temperatura:'',
            frecuencia:equipo.frecuencia?equipo.frecuencia:'',
            presion:equipo.presion?equipo.presion:'',
            potencia:equipo.potencia?equipo.potencia:'',
            alto:equipo.alto?equipo.alto:'',
            ancho:equipo.ancho?equipo.ancho:'',
            largo:equipo.largo?equipo.largo:'',
            peso:equipo.peso?equipo.peso:'',
            idinventario:equipo.idinventario?equipo.idinventario:'',
            urlfactura:equipo.urlfactura?equipo.urlfactura:'',
            urlmanual:equipo.urlmanual?equipo.urlmanual:'',
             // Map new variables
             fechainstalacion: equipo.fechainstalacion ? this.formatearFecha(equipo.fechainstalacion) : '',
             garantia: equipo.garantia ? equipo.garantia : '',
             fechainiciogarantia: equipo.fechainiciogarantia ? this.formatearFecha(equipo.fechainiciogarantia) : '',
            fechafingarantia: equipo.fechafingarantia ? this.formatearFecha(equipo.fechafingarantia) : '',
             velocidad: equipo.velocidad ? equipo.velocidad : '',
             capacidad: equipo.capacidad ? equipo.capacidad : '',
             tipouso: equipo.tipouso ? equipo.tipouso : '',
             pais: equipo.pais ? equipo.pais : '',
             descripcion: equipo.descripcion ? equipo.descripcion : '',
             nombrefabricante: equipo.nombrefabricante ? equipo.nombrefabricante : '',
             emailfabricante: equipo.emailfabricante ? equipo.emailfabricante : '',
             telfabricante: equipo.telfabricante ? equipo.telfabricante : '',
             rutinamto: equipo.rutinamto ? equipo.rutinamto : '',
             recomendaciones: equipo.recomendaciones ? equipo.recomendaciones : '',
             accesorio: equipo.accesorio ? equipo.accesorio : '',
             accesorionombre1: equipo.accesorionombre1 ? equipo.accesorionombre1 : '',
             accesorioref1: equipo.accesorioref1 ? equipo.accesorioref1 : '',
             accesorioserie1: equipo.accesorioserie1 ? equipo.accesorioserie1 : '',
             accesorionombre2: equipo.accesorionombre2 ? equipo.accesorionombre2 : '',
             accesorioref2: equipo.accesorioref2 ? equipo.accesorioref2 : '',
             accesorioserie2: equipo.accesorioserie2 ? equipo.accesorioserie2 : '',
             accesorionombre3: equipo.accesorionombre3 ? equipo.accesorionombre3 : '',
             accesorioref3: equipo.accesorioref3 ? equipo.accesorioref3 : '',
             accesorioserie3: equipo.accesorioserie3 ? equipo.accesorioserie3 : ''
            
    });
  };

  handleOpen = () => {
    this.setState({ open: true,errors:{},
      aprobado:{}});
    this.mapUserDetailsToState(this.props.equipo);
  };
  handleClose = () => {
    if (this.state.aprobado && this.state.aprobado.mensaje) {
        // Si la edición fue exitosa, actualizar el equipo
        this.props.getEquipo(this.props.equipoId);
        
        // Reiniciar el estado
        this.setState({
            open: false,
            errors: {},
            aprobado: {}
        });
        this.props.clearErrors();
    } else {
        // Si no se completó la edición o hubo un error
        this.props.clearErrors();
        this.setState({
            open: false,
            errors: {},
            aprobado: {}
        });
    }
};
  componentDidMount() {
    const { equipo } = this.props;
    this.mapUserDetailsToState(equipo);
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    
    // Special handling for warranty and accessory fields
    if (name === 'garantia' && value === 'false') {
        // If warranty is set to false, clear warranty dates
        this.setState({
            [name]: value,
            fechainiciogarantia: '',
            fechafingarantia: ''
        });
    } else if (name === 'accesorio' && value === 'false') {
        // If accessories is set to false, clear all accessory fields
        this.setState({
            [name]: value,
            accesorionombre1: '',
            accesorioref1: '',
            accesorioserie1: '',
            accesorionombre2: '',
            accesorioref2: '',
            accesorioserie2: '',
            accesorionombre3: '',
            accesorioref3: '',
            accesorioserie3: ''
        });
    } else {
        // Default handling for all other fields
        this.setState({ [name]: value });
    }
};
  handleSubmit = (event) => {
    event.preventDefault();
            const newEquipoData={
                nombre:this.state.nombre,
                marca:this.state.marca,
                registroinvima:this.state.registroinvima,
                modelo:this.state.modelo,
                serie:this.state.serie,
                ubicacion:this.state.ubicacion,
                servicio:this.state.servicio,
                tipo:this.state.tipo,
                clase:this.state.clase,
                riesgo:this.state.riesgo,
                movilfijo:this.state.movilfijo,
                clasbiomedica:this.state.clasbiomedica,
                reqcalibracion:this.state.reqcalibracion,
                adquisicion:this.state.adquisicion,
                costo:this.state.costo,
                fabricacion:this.state.fabricacion,
                operacion:this.state.operacion,
                vidautil:this.state.vidautil,
                proveedor:this.state.proveedor,
                proveedortel:this.state.proveedortel,
                proveedoremail:this.state.proveedoremail,
                tipotec:this.state.tipotec,
                fuente:this.state.fuente,
                tensionmin:this.state.tensionmin,
                tensionmax:this.state.tensionmax,
                corrientemin:this.state.corrientemin,
                corrientemax:this.state.corrientemax,
                frecuencia:this.state.frecuencia,
                temperatura:this.state.temperatura,
                presion:this.state.presion,
                potencia:this.state.potencia,
                alto:this.state.alto,
                ancho:this.state.ancho,
                largo:this.state.largo,
                peso:this.state.peso,
                idinventario:this.state.idinventario,
                urlfactura:this.state.urlfactura,
                urlmanual:this.state.urlmanual,
                fechainstalacion: this.state.fechainstalacion,
                garantia: this.state.garantia,
                fechainiciogarantia: this.state.fechainiciogarantia,
                fechafingarantia: this.state.fechafingarantia,
                velocidad: this.state.velocidad,
                capacidad: this.state.capacidad,
                tipouso: this.state.tipouso,
                pais: this.state.pais,
                descripcion: this.state.descripcion,
                nombrefabricante: this.state.nombrefabricante,
                emailfabricante: this.state.emailfabricante,
                telfabricante: this.state.telfabricante,
                rutinamto: this.state.rutinamto,
                recomendaciones: this.state.recomendaciones,
                accesorio: this.state.accesorio,
                accesorionombre1: this.state.accesorionombre1,
                accesorioref1: this.state.accesorioref1,
                accesorioserie1: this.state.accesorioserie1,
                accesorionombre2: this.state.accesorionombre2,
                accesorioref2: this.state.accesorioref2,
                accesorioserie2: this.state.accesorioserie2,
                accesorionombre3: this.state.accesorionombre3,
                accesorioref3: this.state.accesorioref3,
                accesorioserie3: this.state.accesorioserie3
             
          };
    
     this.props.editEquipoDetails(newEquipoData,this.props.equipoId);
   
  };


 


    render() {
        const { UI:{loading}}=this.props; 
        const {errors}=this.state;
        return (
            <div>
                <Fragment>
            <MyButton tip="Editar Información" onClick={this.handleOpen}>
            <FaPencilAlt color="#03178C" className="icon-crearcliente"/>
             </MyButton>
             <Dialog
             open={this.state.open}
             onClose={this.handleClose}
             fullWidth
             maxWidth="sm"
            >

{this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-aprobado'>
                    <FaCheck color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Reporte Cargado Exitosamente</h2>
              </div>
                
                ) : (<div>
              <DialogTitle>
                <Typography variant="h6" fontWeight="semi-bold" color="primary">
                Editar Detalles del Equipo
              </Typography>
              </DialogTitle>
                          
               <DialogContent>
                     
               <form>
                   <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                   <Typography variant="subtitle1" fontWeight={400} color="primary">Identificacion del Equipo</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      {["nombre", "idinventario", "serie", "modelo", "marca", "ubicacion", "servicio", "registroinvima"].map((name) => (
                        <Grid item xs={12} key={name}>
                          <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            name={name}
                            label={name.charAt(0).toUpperCase() + name.slice(1).replace(/([A-Z])/g, ' $1')}
                            value={this.state[name]}
                            onChange={this.handleChange}
                            helperText={this.state.errors[name]}
                            error={!!this.state.errors[name]}
                          />
                        </Grid>
                      ))}

                      {[{
                        name: "tipouso", label: "Tipo de Uso", options: ["Medico", "Basico", "Apoyo", "N/A"]
                      }, {
                        name: "tipo", label: "Tipo de Aislamiento", options: ["B", "BF", "CF", "N/A"]
                      }, {
                        name: "clase", label: "Clase de Aislamiento", options: ["I", "II", "N/A"]
                      }, {
                        name: "clasbiomedica", label: "Clasificación Biomédica", options: ["Diagnóstico", "Rehabilitación", "Apoyo Vital", "Tratamiento", "Prevención", "Laboratorio", "Industrial", "Mobiliario"]
                      }, {
                        name: "reqcalibracion", label: "¿Requiere Calibración?", options: [{ value: 'true', label: 'Sí' }, { value: 'false', label: 'No' }]
                      }, {
                        name: "riesgo", label: "Clasificación Riesgo", options: ["I", "IIA", "IIB", "III"]
                      }, {
                        name: "movilfijo", label: "¿Equipo es Móvil o Fijo?", options: ["Movil", "Fijo"]
                      }].map(select => (
                        <Grid item xs={12} key={select.name}>
                          <FormControl fullWidth size="small" error={!!this.state.errors[select.name]}>
                            <InputLabel>{select.label}</InputLabel>
                            <Select
                              name={select.name}
                              value={this.state[select.name]}
                              onChange={this.handleChange}
                              label={select.label}
                            >
                              <MenuItem value=""><em>Ninguno</em></MenuItem>
                              {select.options.map(opt => (
                                <MenuItem key={opt.value || opt} value={opt.value || opt}>{opt.label || opt}</MenuItem>
                              ))}
                            </Select>
                            <FormHelperText>{this.state.errors[select.name]}</FormHelperText>
                          </FormControl>
                        </Grid>
                      ))}

                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          multiline
                          rows={4}
                          size="small"
                          variant="outlined"
                          name="descripcion"
                          label="Breve Descripción de Uso"
                          value={this.state.descripcion}
                          onChange={this.handleChange}
                          helperText={this.state.errors.descripcion}
                          error={!!this.state.errors.descripcion}
                        />
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
   
             <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1" fontWeight={400} color="primary">
                      Historial de Adquisición
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <FormControl fullWidth size="small" error={!!this.state.errors.adquisicion}>
                          <InputLabel>Forma Adquisición</InputLabel>
                          <Select
                            name="adquisicion"
                            value={this.state.adquisicion}
                            onChange={this.handleChange}
                            label="Forma Adquisición"
                          >
                            <MenuItem value=""><em>Ninguna</em></MenuItem>
                            {["compra", "comodato", "donacion", "leasing", "otro"].map((option) => (
                              <MenuItem key={option} value={option}>{option.charAt(0).toUpperCase() + option.slice(1)}</MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>{this.state.errors.adquisicion}</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          type="number"
                          name="costo"
                          label="Valor del Equipo"
                          value={this.state.costo}
                          onChange={this.handleChange}
                          helperText={this.state.errors.costo}
                          error={!!this.state.errors.costo}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          type="date"
                          name="fabricacion"
                          label="Fecha Fabricación"
                          value={this.state.fabricacion}
                          onChange={this.handleChange}
                          InputLabelProps={{ shrink: true }}
                          helperText={this.state.errors.fabricacion}
                          error={!!this.state.errors.fabricacion}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          type="date"
                          name="operacion"
                          label="Fecha de Adquisición"
                          value={this.state.operacion}
                          onChange={this.handleChange}
                          InputLabelProps={{ shrink: true }}
                          helperText={this.state.errors.operacion}
                          error={!!this.state.errors.operacion}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          size="small"
                          variant="outlined"
                          type="date"
                          name="fechainstalacion"
                          label="Fecha de Instalación"
                          value={this.state.fechainstalacion}
                          onChange={this.handleChange}
                          InputLabelProps={{ shrink: true }}
                          helperText={this.state.errors.fechainstalacion}
                          error={!!this.state.errors.fechainstalacion}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth size="small" error={!!this.state.errors.garantia}>
                          <InputLabel>¿Equipo en Garantía?</InputLabel>
                          <Select
                            name="garantia"
                            value={this.state.garantia}
                            onChange={this.handleChange}
                            label="¿Equipo en Garantía?"
                          >
                            <MenuItem value=""><em>Ninguna</em></MenuItem>
                            <MenuItem value="true">Sí</MenuItem>
                            <MenuItem value="false">No</MenuItem>
                          </Select>
                          <FormHelperText>{this.state.errors.garantia}</FormHelperText>
                        </FormControl>
                      </Grid>
                      {this.state.garantia === 'true' && [
                        { name: 'fechainiciogarantia', label: 'Fecha Inicio de Garantía' },
                        { name: 'fechafingarantia', label: 'Fecha Final de Garantía' }
                      ].map(field => (
                        <Grid item xs={6} key={field.name}>
                          <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            type="date"
                            name={field.name}
                            label={field.label}
                            value={this.state[field.name]}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                            helperText={this.state.errors[field.name]}
                            error={!!this.state.errors[field.name]}
                          />
                        </Grid>
                      ))}

                      {["pais", "nombrefabricante", "telfabricante", "emailfabricante", "vidautil", "proveedor", "proveedortel", "proveedoremail"].map((name, index) => (
                        <Grid item xs={6} key={name}>
                          <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            type={name.includes('email') ? 'email' : name.includes('tel') || name === 'vidautil' ? 'number' : 'text'}
                            name={name}
                            label={name.replace(/([A-Z])/g, ' $1').replace(/^\w/, c => c.toUpperCase())}
                            value={this.state[name]}
                            onChange={this.handleChange}
                            helperText={this.state.errors[name]}
                            error={!!this.state.errors[name]}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
            <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1" fontWeight={400} color="primary">
                      Datos Técnicos del Equipo
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <FormControl fullWidth size="small" error={!!this.state.errors.tipotec}>
                          <InputLabel>Tecnología Predominante</InputLabel>
                          <Select
                            name="tipotec"
                            value={this.state.tipotec}
                            onChange={this.handleChange}
                            label="Tecnología Predominante"
                          >
                            <MenuItem value=""><em>Ninguna</em></MenuItem>
                            {["Electrónica", "Eléctrica", "Mecánica", "Hidraulica", "Neumatica", "Vapor", "Otra"].map((option) => (
                              <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>{this.state.errors.tipotec}</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item xs={6}>
                        <FormControl fullWidth size="small" error={!!this.state.errors.fuente}>
                          <InputLabel>Fuente de Alimentación</InputLabel>
                          <Select
                            name="fuente"
                            value={this.state.fuente}
                            onChange={this.handleChange}
                            label="Fuente de Alimentación"
                          >
                            <MenuItem value=""><em>Ninguna</em></MenuItem>
                            {["AC", "DC", "Gas Medicinal", "Agua", "Aire", "Aire comprimido", "Energia Solar", "Derivados del Petroleo", "Vapor", "Otra"].map((option) => (
                              <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>{this.state.errors.fuente}</FormHelperText>
                        </FormControl>
                      </Grid>
                      {["urlmanual", "urlfactura"].map((name) => (
                        <Grid item xs={12} key={name}>
                          <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            type="text"
                            name={name}
                            label={name === "urlmanual" ? "Link del Manual o Ficha Técnica" : "Link de Factura o Declaración de Importación"}
                            value={this.state[name]}
                            onChange={this.handleChange}
                            helperText={this.state.errors[name]}
                            error={!!this.state.errors[name]}
                          />
                        </Grid>
                      ))}
                      {[
                        ["tensionmin", "Tensión Min (V)"],
                        ["tensionmax", "Tensión Max (V)"],
                        ["corrientemin", "Corriente Min (A)"],
                        ["corrientemax", "Corriente Max (A)"],
                        ["velocidad", "Velocidad"],
                        ["potencia", "Potencia del Equipo (W)"],
                        ["presion", "Presión"],
                        ["capacidad", "Capacidad"],
                        ["temperatura", "Temperatura de Operación"],
                        ["frecuencia", "Frecuencia (Hz)"],
                        ["alto", "Medidas Alto (cm)"],
                        ["ancho", "Medidas Ancho (cm)"],
                        ["largo", "Medidas Largo (cm)"],
                        ["peso", "Peso (Kg)"]
                      ].map(([name, label], index) => (
                        <Grid item xs={6} key={name}>
                          <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            type="number"
                            name={name}
                            label={label}
                            value={this.state[name]}
                            onChange={this.handleChange}
                            helperText={this.state.errors[name]}
                            error={!!this.state.errors[name]}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                   
   
   
          <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1" fontWeight={400} color="primary">
                      Información Adicional
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          multiline
                          rows={4}
                          fullWidth
                          size="small"
                          label="Rutina de Mantenimiento"
                          name="rutinamto"
                          value={this.state.rutinamto}
                          onChange={this.handleChange}
                          error={!!this.state.errors.rutinamto}
                          helperText={this.state.errors.rutinamto}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          multiline
                          rows={4}
                          fullWidth
                          size="small"
                          label="Recomendaciones de Uso"
                          name="recomendaciones"
                          value={this.state.recomendaciones}
                          onChange={this.handleChange}
                          error={!!this.state.errors.recomendaciones}
                          helperText={this.state.errors.recomendaciones}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControl fullWidth size="small" error={!!this.state.errors.accesorio}>
                          <InputLabel>¿El equipo tiene accesorios?</InputLabel>
                          <Select
                            name="accesorio"
                            value={this.state.accesorio}
                            onChange={this.handleChange}
                            label="¿El equipo tiene accesorios?"
                          >
                            <MenuItem value=""><em>Ninguno</em></MenuItem>
                            <MenuItem value="true">Sí</MenuItem>
                            <MenuItem value="false">No</MenuItem>
                          </Select>
                          <FormHelperText>{this.state.errors.accesorio}</FormHelperText>
                        </FormControl>
                      </Grid>
                      {this.state.accesorio === 'true' && [1, 2, 3].map(i => (
                        <React.Fragment key={i}>
                          <Grid item xs={4}>
                            <TextField
                              fullWidth
                              size="small"
                              label={`Nombre Accesorio ${i}`}
                              name={`accesorionombre${i}`}
                              value={this.state[`accesorionombre${i}`]}
                              onChange={this.handleChange}
                              error={!!this.state.errors[`accesorionombre${i}`]}
                              helperText={this.state.errors[`accesorionombre${i}`]}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Referencia"
                              name={`accesorioref${i}`}
                              value={this.state[`accesorioref${i}`]}
                              onChange={this.handleChange}
                              error={!!this.state.errors[`accesorioref${i}`]}
                              helperText={this.state.errors[`accesorioref${i}`]}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Serie"
                              name={`accesorioserie${i}`}
                              value={this.state[`accesorioserie${i}`]}
                              onChange={this.handleChange}
                              error={!!this.state.errors[`accesorioserie${i}`]}
                              helperText={this.state.errors[`accesorioserie${i}`]}
                            />
                          </Grid>
                        </React.Fragment>
                      ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                          
   
   
   
   
               </form>
                            
               </DialogContent>
                </div>)
                }

            
            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>

             {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                  <MyButton tip="Continuar" onClick={this.handleClose}>
                    <FaCheckCircle color="#20B90C" className="icon-formulario" />
                  </MyButton>
                ) : (
                  <MyButton tip="Actualizar Información" onClick={this.handleSubmit}>
                  <FaPlus  color="#03178C" className="icon-formulario"/>
                   </MyButton>
                )
              )}
         
            
            
          </DialogActions>

            </Dialog>
             </Fragment>

            </div>
        )
    }
}

DetallesEquipo.propTypes = {
    editEquipoDetails: PropTypes.func.isRequired,
    getEquipo:PropTypes.func.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired  
  };

  const mapActionsToProps={editEquipoDetails,getEquipo,clearErrors};

  const mapStateToProps = (state) => ({
    equipo: state.data.equipo.credentials,
    UI:state.UI
  });
  
  export default connect(mapStateToProps,mapActionsToProps)(DetallesEquipo);
